import axios from 'axios';
import { awsUrl, url } from '../../axiosInstance';

export const orderPost = ( data) => {
    return axios.post(`${url}order`, data, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*"
        },
    })
}


export const orderGet = ( data) => {
    return axios.get(`${awsUrl}/v1/orders?from=${data.from}&to=${data.to}&stationId=${data.stationId}`, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        },
    })
}

export const orderPerCustomer = ( customerId) => {
    return axios.get(`${awsUrl}/v1/orders`, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        },
    })
}